// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3t0Db","footer":"ModalUpdate_footer__56jeX"};